module.exports = __webpack_public_path__ + "static/social-c4aba1051be1dc94ba5836ce1a224550.jpg";